import { JS_EVAL_START } from '@atlassian/jira-common-constants/src/analytics-marks.js';
import { stopInitialPageLoadTimingFromPerformanceMarkStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAtlassianNavigation = lazyForPaint<any>(() => {
	const bundleReady = import(
		/* webpackChunkName: "async-atlassian-navigation" */ './ui/index.tsx'
	).then(({ AtlassianNavigation }) => AtlassianNavigation);

	if (!__SERVER__) {
		bundleReady.then(() => {
			stopInitialPageLoadTimingFromPerformanceMarkStart(
				'navigation-primary.bundle-ready',
				'jira-spa.js:eval-stop',
			);
			const resources = performance.getEntriesByType('mark');
			for (let i = resources.length - 1; i >= 0; i -= 1) {
				if (
					(resources[i].name.startsWith('async-navigation') ||
						resources[i].name.startsWith('async-atlassian-navigation')) &&
					resources[i].name.endsWith(JS_EVAL_START)
				) {
					stopInitialPageLoadTimingFromPerformanceMarkStart(
						'navigation-primary.eval',
						resources[i].name,
					);
					break;
				}
			}
		});
	}
	return bundleReady;
});
